export default {
  NONE: 0,
  GET_GOOD_REVIEWS: 1,//用户首次免费试用弹窗提示
  GREET: 2,//Dashboard 打招呼
  ORDER_MESSAGE: 3,//订单页面需要帮助
}